import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "../ui/skeleton";
import { CourseCardSkeleton } from "./course-card-skeleton";
export const CategorizedCoursesLoader = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="h-7 w-65" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-8 flex flex-col items-center justify-between gap-6 text-center md:flex-row md:text-left">{t0}<div className="flex flex-wrap justify-center gap-4"><Skeleton className="h-10 w-40" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="mt-6">{t1}<div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">{[...Array(6)].map(_temp)}</div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp(_, i) {
  return <div key={i} className="p-1"><CourseCardSkeleton /></div>;
}